import { useState, useEffect } from "react";

export const useAppearance = () => {
  const [background, setBackground] = useState<string>("");
  const [fontFamily, setFontFamily] = useState<string>("");

  useEffect(() => {
    const business = sessionStorage.getItem("organization_name");
    const storedColor = sessionStorage.getItem(`background_color${business}`);
    const fontFamily = sessionStorage.getItem(`font_family${business}`);
    
    if (storedColor) {
      setBackground(storedColor);
    }
    
    if (fontFamily) {
      setFontFamily(fontFamily);
      document.documentElement.style.setProperty("--fontfamily", fontFamily);
    }
  }, []);

  return { background, fontFamily };
};